<template>
  <f7-page>
    <navbar :text="$t('PlanningComponent_dailyPlanning')" />
    <DxDailyPlanning />
  </f7-page>
</template>

<script>

import DxDailyPlanning from '../components/dailyPlanning/DxDailyPlanning.vue';
import navbar from '../components/NavBar.vue';

export default {
  components: {
    DxDailyPlanning,
    navbar,
  },
};
</script>

<style>

</style>
